import { useTranslation } from "react-i18next";

export const useI18difference = () => {
  const { t } = useTranslation();

  const tableHead = [
    t("difference.table.1"),
    t("difference.table.2"),
    t("difference.table.3"),
    t("difference.table.4"),
  ];

  const rows = [
    {
      name: t("difference.rows.name.1"),
      vpn: false,
      proxy: true,
      anonymizer: true,
    },
    {
      name: t("difference.rows.name.2"),
      vpn: false,
      proxy: true,
      anonymizer: true,
    },
    {
      name: t("difference.rows.name.3"),
      vpn: false,
      proxy: true,
      anonymizer: true,
    },
    {
      name: t("difference.rows.name.4"),
      vpn: false,
      proxy: true,
      anonymizer: true,
    },
    {
      name: t("difference.rows.name.5"),
      vpn: false,
      proxy: true,
      anonymizer: true,
    },
    {
      name: t("difference.rows.name.6"),
      vpn: false,
      proxy: true,
      anonymizer: true,
    },
    {
      name: t("difference.rows.name.7"),
      vpn: false,
      proxy: true,
      anonymizer: true,
    },
    {
      name: t("difference.rows.name.8"),
      vpn: false,
      proxy: true,
      anonymizer: true,
    },
  ];

  return { tableHead, rows };
};
